import { render, staticRenderFns } from "./ErrorAccess.vue?vue&type=template&id=7dfdad20&"
import script from "./ErrorAccess.vue?vue&type=script&lang=js&"
export * from "./ErrorAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports